import React from 'react'
import {
  useApplicationState
} from '../state/root'

/*
  Used to determine the first render
*/
export const useInitialMountState = () => {
  const isInitialyMounted = React.useRef(true)

  if (isInitialyMounted.current) {
    isInitialyMounted.current = false
    return true
  }

  return false
}

export const useUpdateEffect = (callback, dependencies) => {
  const isInitialMount = useInitialMountState()

  React.useEffect(
    () => {
      if (isInitialMount === false) {
        return callback()
      }
    },
    dependencies
  )
}

export const useAuthorizationEffect = (callback) => {
  const { authenticated } = useApplicationState()

  return React.useEffect(
    () => {
      return callback(authenticated)
    },
    [authenticated]
  )
}
